import ENDPOINTS from 'tradera-constants/endpoints';
import {
    axiosWithTokenRefresh,
    checkResponseVersion,
    defaultJsonRequestHeaders,
    finalizeResponse,
    handleError,
    utilizeCancelToken
} from 'tradera-utils/api';
import initData from 'init-data';

// Prevents URL:s that begins with // when that was not intended.
const getSafeUrl = (baseUrl, url) => {
    if (baseUrl.endsWith('/') && url.startsWith('/')) {
        return baseUrl + url.substring(1);
    }
    return baseUrl + url;
};

const httpClient = baseUrl => ({
    get: (url, httpClientConfig = { headers: defaultJsonRequestHeaders }) => {
        let { cancelTokenId, ...axiosConfig } = httpClientConfig;
        const version = initData.version;
        if (cancelTokenId) {
            const { cancel, cancelToken } = utilizeCancelToken(cancelTokenId);
            axiosConfig.cancelToken = cancelToken;
            if (cancel) {
                cancel();
            }
        }
        return axiosWithTokenRefresh()
            .get(getSafeUrl(baseUrl, url), axiosConfig)
            .then(
                version ? checkResponseVersion(version) : response => response
            )
            .then(finalizeResponse())
            .catch(handleError());
    },
    post: (
        url,
        payload,
        httpClientConfig = { headers: defaultJsonRequestHeaders }
    ) => {
        let { cancelTokenId, ...axiosConfig } = httpClientConfig;
        const version = initData.version;
        if (cancelTokenId) {
            const { cancel, cancelToken } = utilizeCancelToken(cancelTokenId);
            axiosConfig.cancelToken = cancelToken;
            if (cancel) {
                cancel();
            }
        }
        return axiosWithTokenRefresh()
            .post(getSafeUrl(baseUrl, url), payload, axiosConfig)
            .then(
                version ? checkResponseVersion(version) : response => response
            )
            .then(finalizeResponse())
            .catch(handleError());
    }
});

export const defaultClient = httpClient('');
export const touchWebClient = httpClient(ENDPOINTS.TOUCHWEB_URL); // ENDPOINTS.TOUCHWEB_URL is localized.
